import api from "../api/api";

class PermissionService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/permission${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/permission?page=${page}`).then(r => r.data).catch(err => err);
            } else {
                return await api.get(`/permission`).then(r => r.data).catch(err => err);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/permission/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/permission", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/permission/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/permission/${id}`).then(response => response.data).catch(err => err);
    }
}

const permissionService = new PermissionService();

export default permissionService;